import _defineProperty from "/app/node_modules/next/dist/compiled/@babel/runtime/helpers/esm/defineProperty.js";
import _objectWithoutProperties from "/app/node_modules/next/dist/compiled/@babel/runtime/helpers/esm/objectWithoutProperties.js";
var _excluded = ["label", "required", "error", "type", "errorMessage", "multiline", "rows", "minRows", "link", "autoComplete"];

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? ownKeys(Object(source), !0).forEach(function (key) { _defineProperty(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }

import { addValidProtocol, hasProtocol, isValidUrl } from '@infl-ts/util-url';
import { InputAdornment, TextField } from '@mui/material';
import { Controller } from 'react-hook-form';
import { Translation } from 'react-i18next';
import { getErrorMessage } from './form-helpers';
import { jsx as _jsx } from "react/jsx-runtime";

var TextFormField = function TextFormField(_ref) {
  var label = _ref.label,
      required = _ref.required,
      error = _ref.error,
      type = _ref.type,
      errorMessage = _ref.errorMessage,
      multiline = _ref.multiline,
      rows = _ref.rows,
      minRows = _ref.minRows,
      link = _ref.link,
      autoComplete = _ref.autoComplete,
      controllerProps = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/_jsx(Controller, _objectSpread(_objectSpread({}, controllerProps), {}, {
    rules: _objectSpread({
      required: required,
      validate: function validate(value) {
        return (typeof value === 'string' || value === null) && (!link || value.length === 0 || isValidUrl(addValidProtocol(value)));
      }
    }, controllerProps.rules),
    render: function render(_ref2) {
      var field = _ref2.field;
      return /*#__PURE__*/_jsx(Translation, {
        children: function children(t) {
          return /*#__PURE__*/_jsx(TextField, _objectSpread(_objectSpread({
            sx: {
              width: 1
            }
          }, field), {}, {
            onChange: field.onChange,
            value: field.value,
            InputProps: {
              startAdornment: link && !hasProtocol(field.value) ? /*#__PURE__*/_jsx(InputAdornment, {
                sx: {
                  mb: '1px'
                },
                position: "start",
                children: "https://"
              }) : null
            },
            required: required,
            multiline: multiline,
            rows: rows,
            minRows: minRows,
            label: label,
            error: !!error,
            type: type,
            autoComplete: autoComplete,
            helperText: error && t(getErrorMessage(error, errorMessage)),
            FormHelperTextProps: {
              sx: {
                ml: 0
              }
            },
            variant: "outlined",
            size: "small",
            InputLabelProps: {
              shrink: true
            }
          }));
        }
      });
    },
    "data-element": "Controller",
    "data-component": "TextFormField",
    "data-source-file": "text-form-field.tsx"
  }));
};

export default TextFormField;